import { SVGAttributes } from 'react';

const QRcodeIcon = (props: SVGAttributes<SVGSVGElement>) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="1000.000000pt"
            height="1000.000000pt"
            viewBox="0 0 1000.000000 1000.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g
                transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
            >
                <path
                    d="M4063 9512 l-153 -3 0 -154 0 -155 -155 0 -155 0 0 155 0 155 -155 0
-154 0 -3 -152 -3 -153 -152 -3 -153 -3 0 -154 0 -155 155 0 155 0 0 -465 0
-465 155 0 155 0 0 465 0 465 310 0 310 0 0 -155 0 -155 -155 0 -155 0 0 -310
0 -310 155 0 155 0 0 -315 0 -316 -152 3 -153 3 -3 158 -3 157 -154 0 -155 0
0 -160 0 -160 155 0 155 0 0 -155 0 -155 155 0 155 0 0 -155 0 -155 -310 0
-310 0 0 -155 0 -155 -155 0 -155 0 0 155 0 155 -310 0 -310 0 0 155 0 155
-160 0 -160 0 0 -155 0 -155 160 0 161 0 -3 -152 -3 -153 -157 -3 -158 -3 0
-154 0 -155 -310 0 -310 0 0 310 0 310 -310 0 -310 0 0 -465 0 -465 155 0 155
0 0 -155 0 -155 155 0 155 0 0 155 0 155 310 0 310 0 0 -155 0 -154 158 -3
157 -3 3 -152 3 -153 -471 0 -470 0 0 -161 0 -160 -158 1 c-86 1 -226 1 -309
1 l-152 -1 -3 -152 -3 -153 -153 -3 -152 -3 0 316 0 316 155 -3 155 -3 0 158
0 157 -155 0 -155 0 0 310 0 310 -155 0 -154 0 -3 -162 c-2 -90 -2 -229 0
-310 l3 -147 152 -3 152 -3 3 -152 3 -153 -155 0 -155 0 -3 -162 c-2 -90 -2
-232 0 -315 l3 -153 155 0 155 0 -3 -152 -3 -153 -152 -3 -153 -3 0 -154 0
-155 310 0 310 0 0 -155 0 -155 155 0 155 0 0 155 0 155 155 0 155 0 0 -310 0
-310 310 0 310 0 0 -155 0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 155
0 155 315 0 315 0 0 -777 c0 -428 0 -849 0 -935 l0 -158 155 0 155 0 0 -155 0
-155 155 0 155 0 0 310 0 310 155 0 155 0 0 -465 0 -465 155 0 155 0 0 -155 0
-155 -465 0 -465 0 0 -155 0 -155 465 0 465 0 0 155 0 155 310 0 310 0 0 -155
0 -155 160 0 160 0 0 465 0 465 155 0 155 0 0 -310 0 -310 155 0 155 0 0 155
0 155 155 0 155 0 0 -155 0 -155 155 0 155 0 0 155 0 155 155 0 155 0 0 -310
0 -310 155 0 c85 0 227 -1 315 -1 88 0 230 1 315 1 l155 0 0 155 0 156 153 -3
152 -3 3 -152 3 -152 147 -3 c81 -2 220 -2 310 0 l162 3 0 309 0 310 -155 0
-155 0 0 -155 0 -155 -155 0 -155 0 0 155 0 155 -315 0 -315 0 0 155 0 155
-465 0 -465 0 0 155 0 155 625 0 625 0 0 -155 0 -155 155 0 155 0 0 155 0 155
155 0 155 0 0 -155 0 -155 310 0 310 0 0 -465 0 -465 155 0 154 0 3 153 3 152
153 3 152 3 0 309 0 310 -155 0 -155 0 0 155 0 155 155 0 155 0 0 155 0 154
-152 3 -153 3 -3 153 -3 152 155 0 155 0 3 162 c2 90 2 232 0 316 l-3 152
-154 0 -155 0 0 310 0 310 155 0 155 0 0 310 c0 171 0 661 0 1090 0 429 0 989
0 1245 l0 464 -152 3 -153 3 -3 153 -3 152 -154 0 -155 0 0 -310 0 -310 155 0
155 0 0 -155 0 -155 -155 0 -155 0 0 -155 0 -155 155 0 155 0 0 -625 0 -625
-155 0 -155 0 0 -155 0 -155 -465 0 -465 0 0 310 0 310 155 0 155 0 0 -155 0
-155 155 0 155 0 0 155 0 155 -155 0 -155 0 0 315 0 315 -155 0 -155 0 0 155
0 155 310 0 310 0 0 465 0 465 -310 0 -310 0 0 155 0 154 -162 3 c-90 2 -232
2 -315 0 l-153 -3 0 -309 0 -310 -155 0 -155 0 0 306 c0 169 -1 309 -3 311 -2
2 -142 3 -311 3 l-306 0 2 313 3 312 153 3 152 3 0 -161 0 -160 155 0 154 0 3
163 c2 89 2 231 0 315 l-3 152 -309 0 -310 0 0 155 0 155 310 0 310 0 0 465 0
465 -155 0 -155 0 0 155 0 155 -310 0 -310 0 0 -310 0 -310 -155 0 -155 0 0
155 0 155 -155 0 -155 0 0 -155 0 -155 155 0 155 0 0 -155 0 -155 155 0 155 0
0 155 0 155 155 0 155 0 0 -310 0 -310 -155 0 -155 0 -2 -467 -3 -468 -152 -3
-153 -3 0 161 0 160 -155 0 -154 0 -3 -157 -3 -158 -152 -3 -153 -3 0 781 0
780 -160 0 -160 0 0 -310 0 -310 -155 0 -155 0 0 -155 0 -155 -155 0 -155 0 0
310 0 310 155 0 154 0 3 313 c2 171 2 380 0 464 l-3 152 -157 3 c-86 2 -226 2
-309 0z m2647 -467 l0 -155 -155 0 -155 0 0 155 0 155 155 0 155 0 0 -155z
m-1870 -1555 l0 -161 -152 3 -153 3 -3 145 c-1 79 0 150 2 157 4 10 42 13 156
13 l150 0 0 -160z m940 -315 l0 -155 155 0 155 0 0 -155 0 -155 155 0 155 0 0
-155 0 -155 155 0 155 0 0 -155 0 -155 -155 0 -155 0 0 -155 0 -155 465 0 465
0 0 153 c1 83 1 223 0 310 l-1 157 161 0 160 0 0 155 0 155 155 0 155 0 0
-155 0 -155 155 0 155 0 0 -155 0 -155 -310 0 -309 0 -3 -162 c-2 -90 -2 -229
0 -310 l3 -147 152 -3 152 -3 0 -310 0 -310 -152 -3 -153 -3 0 -152 c-1 -83
-2 -222 -3 -307 l-2 -155 -155 0 -155 0 -2 155 c-1 85 -2 224 -3 307 l0 152
-152 3 -153 3 -3 158 -3 157 -154 0 -155 0 0 -160 0 -160 155 0 155 0 0 -155
0 -155 -310 0 -310 0 0 315 0 315 -465 0 -465 0 0 -157 c-1 -87 -2 -228 -3
-313 l-2 -155 -152 -3 -153 -3 0 471 0 470 -160 0 -160 0 0 -155 0 -155 -155
0 -155 0 0 -160 0 -161 -152 3 -153 3 -3 158 -3 157 -154 0 -154 0 -3 -157 -3
-158 -152 -3 -153 -3 0 161 0 160 -310 0 -310 0 0 155 0 155 -155 0 -155 0 0
155 0 155 -160 0 -160 0 0 155 0 156 157 -3 158 -3 3 -152 3 -152 152 -3 152
-3 3 -152 3 -152 147 -3 c81 -2 220 -2 310 0 l162 3 0 154 0 155 -155 0 -155
0 0 155 0 155 155 0 155 0 0 -155 0 -155 155 0 155 0 0 310 0 310 310 0 310 0
0 158 c1 86 1 226 0 310 l-1 152 156 0 155 0 0 -155 0 -155 160 0 160 0 0 155
0 155 155 0 155 0 0 155 0 155 155 0 155 0 0 -155z m-4050 -1240 l0 -155 -155
0 -155 0 0 155 0 155 155 0 155 0 0 -155z m1248 -937 l3 -158 155 0 155 0 -3
-152 -3 -153 -310 -2 c-170 -1 -381 -3 -467 -3 l-158 0 0 -155 0 -155 160 0
161 0 -3 -152 -3 -153 -157 -3 -158 -3 0 -154 0 -155 -155 0 -155 0 0 155 0
155 -155 0 -155 0 0 155 0 155 -155 0 -155 0 0 155 0 155 310 0 310 0 0 155 0
155 315 0 315 0 0 160 0 161 153 -3 152 -3 3 -157z m1242 -623 l0 -155 155 0
155 0 0 155 0 155 155 0 155 0 0 -155 0 -155 160 0 160 0 0 -155 0 -155 155 0
155 0 0 155 0 155 155 0 155 0 0 155 0 155 155 0 155 0 0 -155 0 -155 310 0
310 0 0 -310 0 -310 -310 0 -310 0 0 -155 0 -155 310 0 310 0 0 -155 0 -155
-155 0 -155 0 0 -315 0 -315 -461 0 c-254 0 -464 -1 -465 -3 -2 -2 -5 -141 -7
-308 l-2 -304 -152 -3 -153 -3 0 156 0 155 -160 0 -160 0 0 -155 0 -155 -155
0 -155 0 0 -155 0 -155 155 0 155 0 0 -155 0 -155 -155 0 -155 0 0 155 0 155
-155 0 -155 0 0 155 0 155 155 0 155 0 0 158 c1 255 -1 456 -4 459 -2 2 -211
3 -465 3 l-461 0 0 160 0 160 -155 0 -155 0 0 465 0 465 -155 0 -155 0 0 155
0 155 155 0 155 0 0 155 0 155 155 0 155 0 0 155 0 155 310 0 310 0 0 -155z
m3110 -310 l0 -155 470 0 470 0 0 -310 0 -310 155 0 155 0 0 155 0 155 155 0
155 0 0 310 0 310 155 0 155 0 0 -310 0 -310 -155 0 -155 0 0 -310 0 -310 155
0 155 0 0 -315 0 -316 -155 3 -155 3 0 -312 0 -313 -310 0 -310 0 0 155 0 155
155 0 155 0 0 155 0 155 -155 0 -155 0 0 470 0 470 -155 0 -155 0 0 155 0 155
-155 0 -155 0 0 -155 0 -155 -315 0 -315 0 0 465 0 465 155 0 155 0 0 -155z
m625 -1555 l0 -465 -465 0 -465 0 -2 455 c-2 250 -1 461 2 467 3 10 106 12
467 10 l463 -2 0 -465z m-1555 -625 l0 -155 -155 0 -155 0 0 -155 0 -155 -155
0 -155 0 0 310 0 310 310 0 310 0 0 -155z"
                />
                <path
                    d="M5158 6555 l-3 -155 158 0 157 0 0 -310 0 -310 -155 0 -155 0 0 155
0 155 -315 0 -315 0 0 -155 0 -155 -310 0 -310 0 0 -155 0 -154 313 -3 c171
-2 381 -2 464 0 l152 3 3 152 3 152 155 0 155 0 3 -152 3 -152 152 -3 c83 -2
362 -2 620 0 l467 2 0 155 0 155 -310 0 -310 0 0 310 0 310 155 0 155 0 0 155
0 155 -465 0 -464 0 -3 -155z"
                />
                <path d="M7330 5315 l0 -154 160 -3 160 -3 0 158 0 157 -160 0 -160 0 0 -155z" />
                <path
                    d="M3600 3445 l0 -775 155 0 155 0 0 310 0 310 155 0 155 0 0 310 0 310
-155 0 -155 0 0 155 0 155 -155 0 -155 0 0 -775z"
                />
                <path
                    d="M4840 3755 l0 -155 -155 0 -155 0 0 -310 0 -310 155 0 155 0 0 -155
0 -155 -155 0 -155 0 0 -160 0 -160 470 0 470 0 0 160 0 160 310 -2 310 -3 0
158 0 157 -310 0 -310 0 0 155 0 155 155 0 155 0 0 155 0 155 155 0 155 0 0
155 0 155 -155 0 -155 0 0 -155 0 -155 -155 0 -155 0 0 -155 0 -155 -315 0
-316 0 3 153 3 152 158 3 157 3 0 154 0 155 -160 0 -160 0 0 -155z m628 -932
l3 -153 -156 0 -155 0 0 155 0 156 153 -3 152 -3 3 -152z"
                />
                <path d="M8580 2825 l0 -155 155 0 155 0 0 155 0 155 -155 0 -155 0 0 -155z" />
                <path d="M7330 2510 l0 -160 160 0 160 0 0 160 0 160 -160 0 -160 0 0 -160z" />
                <path
                    d="M490 8425 l0 -1085 1085 0 1085 0 0 1085 0 1085 -1085 0 -1085 0 0
-1085z m1868 -2 l-3 -778 -777 -3 -778 -2 0 780 0 780 780 0 780 0 -2 -777z"
                />
                <path d="M1110 8425 l0 -465 465 0 465 0 0 465 0 465 -465 0 -465 0 0 -465z" />
                <path d="M4840 9355 l0 -155 160 0 160 0 0 155 0 155 -160 0 -160 0 0 -155z" />
                <path
                    d="M7340 8425 l0 -1085 1085 0 1085 0 0 1085 0 1085 -1085 0 -1085 0 0
-1085z m1860 -5 l0 -780 -777 2 -778 3 -3 778 -2 777 780 0 780 0 0 -780z"
                />
                <path d="M7960 8425 l0 -465 465 0 465 0 0 465 0 465 -465 0 -465 0 0 -465z" />
                <path d="M5470 8115 l0 -155 155 0 155 0 0 155 0 155 -155 0 -155 0 0 -155z" />
                <path d="M2980 7490 l0 -160 155 0 155 0 0 160 0 160 -155 0 -155 0 0 -160z" />
                <path d="M490 6555 l0 -155 155 0 155 0 0 155 0 155 -155 0 -155 0 0 -155z" />
                <path d="M8580 5315 l0 -155 155 0 155 0 0 155 0 155 -155 0 -155 0 0 -155z" />
                <path
                    d="M490 3135 l0 -154 148 -3 c81 -2 220 -2 310 0 l162 3 0 154 0 155
-310 0 -310 0 0 -155z"
                />
                <path
                    d="M490 1575 l0 -1085 1085 0 1085 0 0 1085 0 1085 -1085 0 -1085 0 0
-1085z m1868 3 l2 -778 -780 0 -780 0 0 780 0 780 778 -2 777 -3 3 -777z"
                />
                <path d="M1110 1575 l0 -465 465 0 465 0 0 465 0 465 -465 0 -465 0 0 -465z" />
            </g>
        </svg>
    );
};

export default QRcodeIcon;
